import { MdShare } from "react-icons/md";
import { shareOnMobile } from "react-mobile-share";
import { isMobile } from "../utils/deviceDetect";

export interface ShareButtonProps {
  onClick: () => void;
  url?: string;
  title?: string;
}

const ShareButton = ({ onClick, url, title }: ShareButtonProps) => {
  const handleClick = () => {
    if (isMobile) {
      // モバイルの場合はネイティブのシェア機能を使用
      shareOnMobile({
        text: "",
        url: url || window.location.href,
        title: title || document.title,
      }, (error) => {
        console.error("Share failed:", error);
      });
    } else {
      // PCの場合は通常のシェアモーダルを表示
      onClick();
    }
  };

  return (
    <button
      className="tw-text-white tw-bg-transparent tw-border-none tw-outline-none tw-shadow-none hover:tw-cursor-pointer"
      onClick={handleClick}
    >
      <MdShare size="1.2rem" />
    </button>
  );
};

export default ShareButton; 